(() => {
  // Loads the reviews.io scripts only when a star snippet or the reviews widget comes near the screen,
  // instead of on every page load. Star snippets keep the settings of the reviews.io rating snippet embed.
  // Discovery search and collection cards load and style their own stars, so they are left alone.
  const SNIPPET_JS = 'https://widget.reviews.io/rating-snippet/dist.js';
  const SNIPPET_CSS = 'https://widget.reviews.io/rating-snippet/dist.css';
  const POLARIS_JS = 'https://widget.reviews.io/polaris/build.js';
  const MARGIN = '300px 0px';
  const scripts = {};
  const store = () => window.reviewsIoStore || 'charterhouse-aquatics.myshopify.com';

  function loadScript(src) {
    scripts[src] = scripts[src] || new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return scripts[src];
  }

  function loadStylesheet(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  let snippetsRequested = false;
  function loadSnippets() {
    if (snippetsRequested) return;
    snippetsRequested = true;
    loadStylesheet(SNIPPET_CSS);
    loadScript(SNIPPET_JS).then(() => {
      if (typeof window.ratingSnippet !== 'function') return;
      window.ratingSnippet('ruk_rating_snippet', {
        store: store(),
        color: '#000',
        textClr: '#333',
        linebreak: false,
        usePolaris: true,
        text: 'Reviews',
        lang: window.reviewsIoLang || 'en',
        mode: 'default',
        showEmptyStars: false,
        enableSyndication: window.reviewsIoEnableSyndication || false
      });
      // Recommendation sections style their own stars, and skip that step if the script wasn't there yet.
      document.querySelectorAll('smart-recommendations').forEach(section => section.initRatings?.());
    }).catch(() => {});
  }

  function loadWidget(root) {
    if (root.dataset.reviewsioInitialized === 'true') return;
    const config = root.parentElement.querySelector('script[data-reviews-widget-config]');
    if (!config) return;
    root.dataset.reviewsioInitialized = 'true';
    loadScript(POLARIS_JS).then(() => {
      if (typeof window.ReviewsWidget !== 'function') return;
      const settings = JSON.parse(config.textContent);
      settings.store = store();
      new window.ReviewsWidget(`#${root.id}`, settings);
    }).catch(() => { root.dataset.reviewsioInitialized = 'false'; });
  }

  function trigger(target) {
    if (target.matches('[data-reviews-widget]')) loadWidget(target);
    else loadSnippets();
  }

  // A section with no height yet is still filling in. It counts as on screen wherever it will end up,
  // so it is checked again once it has a size.
  const resizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver(entries => {
        entries.forEach(entry => {
          const rect = entry.target.getBoundingClientRect();
          if (!rect.height) return;
          resizeObserver.unobserve(entry.target);
          if (rect.top < window.innerHeight + 300 && rect.bottom > -300) {
            observer.unobserve(entry.target);
            trigger(entry.target);
          }
        });
      })
    : null;

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          if (!entry.boundingClientRect.height && resizeObserver) {
            resizeObserver.observe(entry.target);
            return;
          }
          observer.unobserve(entry.target);
          trigger(entry.target);
        });
      }, { rootMargin: MARGIN })
    : null;

  const SELECTOR = '.ruk_rating_snippet:not(.discovery-search__rating-snippet, .discovery-collection__rating-snippet), [data-reviews-widget]';
  function watch(element) {
    // Empty snippets are often hidden until their stars arrive, and a hidden element always counts as on screen,
    // so a snippet is watched through its section instead.
    const target = element.matches('[data-reviews-widget]') ? element : element.closest('.shopify-section') || element.parentElement;
    if (!target || target.dataset.reviewsWatched) return;
    target.dataset.reviewsWatched = 'true';
    if (observer) observer.observe(target);
    else trigger(target);
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(SELECTOR)) watch(root);
    root.querySelectorAll(SELECTOR).forEach(watch);
  }

  // Start after the page has loaded, when the layout has settled and sections sit where they will stay.
  function start() {
    scan(document.body);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
